<template>
    <!-- Header -->
    <div id="header" class="bg-san-marino-50 font-outfit">
        <div class="max-w-screen-xl mx-auto">
            <div class="flex flex-col py-4 sm:py-6 md:py-8 lg:py-9">
                <div class="flex flex-col px-4 sm:px-6 md:px-16 lg:px-32 sm:flex-row justify-between">
                    <div class="flex flex-col sm:flex-row sm:gap-x-4 md:gap-x-8 lg:gap-x-14 xl:gap-x-40">
                        <NuxtLink to="/" class="mb-4 sm:mb-0">
                            <NuxtImg src="/kolayesim-logo.svg" alt="Kolay Esim Logo" class="mx-auto sm:mx-0" width="125" height="38" />
                        </NuxtLink>
                        <div class="flex flex-row justify-center sm:items-center gap-x-4 sm:gap-x-6 lg:gap-x-6 xl:gap-x-12 text-san-marino-500 text-sm sm:text-base font-medium">
                            <NuxtLink to="#how-to-works">Nasıl Çalışır?</NuxtLink>
                            <NuxtLink to="#compatible-devices">Uyumlu Cihazlar</NuxtLink>
                            <NuxtLink to="#frequently-asked-questions">SSS</NuxtLink>
                            <a href="https://kolayesim.com/blog" target="_blank">Blog</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Main -->
    <div class="bg-san-marino-50 font-outfit">
        <NuxtPage />
    </div>
    <!-- Footer -->
    <div id="footer" class="bg-san-marino-100 font-outfit border-t-2 border-san-marino-200">
        <div class="max-w-screen-xl mx-auto">
            <div class="flex flex-col items-center pb-5 px-4 sm:px-6 md:px-16 lg:px-32 gap-y-5">
                <div class="flex flex-col sm:flex-row py-2 justify-between gap-y-8 sm:gap-x-4 md:gap-x-8 lg:gap-x-12 border-b-2 border-san-marino-200 w-full">
                    <!-- About Us -->
                    <div class="flex flex-col w-full sm:w-1/2 md:w-1/4 py-2 gap-y-2">
                        <NuxtImg src="/kolayesim-logo.svg" alt="Kolay Esim Logo" class="w-[100px] sm:w-[125px]" width="125" height="38" loading="lazy" />
                        <span class="text-san-marino-700 text-xs font-medium">
                            Kolay eSIM, size dünya çapında 200’den fazla eSIM’e
                            (dijital SIM kart) uygun fiyatlarla erişim
                            sağlayarak yüksek dolaşım faturalarına son veren
                            Türkiye'nin ilk eSIM mağazasıdır.
                        </span>
                    </div>
                    <!-- Popular Countries -->
                    <div class="flex flex-col w-full sm:w-1/2 md:w-1/4 py-2 gap-y-2">
                        <span class="text-san-marino-800 font-bold text-sm">
                            Popüler Ülkeler
                        </span>
                        <span
                            class="text-san-marino-700 text-xs font-medium"
                            v-for="country in popularCountries">
                            <NuxtLink
                                :to="`/${country.slug}`"
                                class="flex items-center gap-x-2">
                                {{ country.name }}
                            </NuxtLink>
                        </span>
                    </div>
                    <!-- More Information -->
                    <div class="flex flex-col w-full sm:w-1/2 md:w-1/4 py-2 gap-y-2">
                        <span class="text-san-marino-800 font-bold text-sm">
                            Daha Fazla Bilgi
                        </span>
                        <span class="text-san-marino-700 text-xs font-medium hidden">
                            Yardım Merkezi
                        </span>
                        <span class="text-san-marino-700 text-xs font-medium"
                            ><a href="https://kolayesim.com/blog" target="_blank">Blog</a>
                        </span>
                        <span class="text-san-marino-700 text-xs font-medium"
                            ><NuxtLink to="/all-countries"
                                >Tüm Ülkeler</NuxtLink
                            >
                        </span>
                        <span class="text-san-marino-700 text-xs font-medium"
                            ><NuxtLink to="/privacy-policy"
                                >Gizlilik ve Çerez Politikası</NuxtLink
                            >
                        </span>
                        <span class="text-san-marino-700 text-xs font-medium"
                            ><NuxtLink to="/terms-and-conditions"
                                >Hüküm ve Koşullar</NuxtLink
                            ></span
                        >
                    </div>
                    <!-- Follow Us -->
                    <div class="flex flex-col w-full sm:w-1/2 md:w-1/4 py-2 gap-y-2">
                        <span class="text-san-marino-800 font-bold text-sm">
                            Bizi Takip Edin
                        </span>
                        <div class="flex flex-row gap-x-4 sm:flex-col sm:gap-y-2">
                            <NuxtLink to="https://www.facebook.com/profile.php?id=61569149594537" target="_blank">
                                <NuxtImg
                                    src="/facebook.svg"
                                    width="24"
                                    height="24"
                                    class="w-6"
                                    loading="lazy"
                                    alt="Facebook Kolay Esim Page" />
                            </NuxtLink>
                            <NuxtLink to="https://www.instagram.com/kolayesim/" target="_blank">
                                <NuxtImg
                                    src="/instagram.svg"
                                    width="24"
                                    height="24"
                                    class="w-6"
                                    loading="lazy"
                                    alt="Instagram Kolay Esim Page" />
                            </NuxtLink>
                            <NuxtLink to="https://x.com/kolayesim" target="_blank">
                                <NuxtImg
                                    src="/x.svg"
                                    width="24"
                                    height="24"
                                    class="w-6"
                                    loading="lazy"
                                    alt="X Kolay Esim Page" />
                            </NuxtLink>
                            <NuxtLink to="https://www.youtube.com/@kolayesim" target="_blank">
                                <NuxtImg
                                    src="/youtube.svg"
                                    width="24"
                                    height="24"
                                    class="w-6"
                                    loading="lazy"
                                    alt="Youtube Kolay Esim Page" />
                            </NuxtLink>
                            <NuxtLink to="https://linkedin.com/company/kolay-esim" target="_blank">
                                <NuxtImg
                                    src="/linkedin.svg"
                                    width="24"
                                    height="24"
                                    class="w-6"
                                    loading="lazy"
                                    alt="Linkedin Kolay Esim Page" />
                            </NuxtLink>
                        </div>
                    </div>
                </div>
                <span class="text-san-marino-700 text-xs sm:text-sm text-center">
                    Telif Hakkı © 2024 Lokum Tech LLC. Tüm hakları saklıdır.
                    Kolay eSIM™ bir ticari markamızdır.
                </span>
                <div class="fixed bottom-4 right-4 sm:bottom-10 sm:right-10">
                    <ScrollTop />
                </div>
            </div>
        </div>
    </div>
    <!-- Fixed Support Button -->
    <NuxtLink 
        to="https://wa.me/905322703746?text=Merhaba%2C%20eSIM%20konusunda%20destek%20alabilir%20miyim%3F" 
        target="_blank"
        class="fixed bottom-24 right-6 md:bottom-28 md:right-12 z-50 ">
        <img src="/whatsapp.svg" alt="WhatsApp Destek" class="w-16 h-16"/>
    </NuxtLink>
</template>

<script setup>
import { ref } from "vue";

const client = useSanctumClient();

useHead({
    htmlAttrs: {
        class: "scroll-smooth",
        lang: "tr",
    },
});

const { data: countries, pending, error, refresh } = await useAsyncData("countries", () =>
    client("/countries")
);

const popularCountries = ref([
    { code: "GR" },
    { code: "DE" },
    { code: "IT" },
    { code: "ES" },
    { code: "GB" },
    { code: "US" },
    { code: "NL" },
    { code: "JP" },
    { code: "AE" },
    { code: "TH" },
]);

popularCountries.value.forEach((country) => {
    country.name = countries.value.find((c) => c.code === country.code).name;
    country.slug = countries.value.find((c) => c.code === country.code).slug;
});
</script>
